import {Basic, Ventrata} from 'types'
import {formatMoney} from 'utils/formatMoney'
import {getProductPricingFromBooking} from '../../utils/getProductPricingFrom'

type CostFromBookingProps = {
  product: Ventrata.Product
  currency: Basic.Currency
}

export const CostFromPerBooking = ({product, currency}: CostFromBookingProps) => {
  const amount = getProductPricingFromBooking(product, currency)

  if (amount === undefined) {
    return <div className="font-medium text-red-500">No pricing found for currency: {currency}</div>
  }

  return <div className="font-medium">{formatMoney(amount, currency, {minimumFractionDigits: 0})}/booking</div>
}
